export function Brand({ light = false }: { light?: boolean }) {
  return <a className={`market-brand ${light ? "market-brand-light" : ""}`} href="/" aria-label="G3.AI, página principal"><span className="market-brand-symbol">G3</span><span>G3<span>.AI</span></span></a>;
}
